import { AppLoading } from 'common/components/appLoading/appLoading';
import { useEffect, useState } from 'react';
import { IntegrationHeader } from '../Integration/IntegrationHeader/IntegrationHeader';
import '../Integration.scss';
import { ButtonsWrapper } from '../Integration/ButtonsWrapper/ButtonsWrapper';
import { TextField } from '@mui/material';
import { RestApi } from 'common/services/rest-api.service';
import { ISplunk, FIELDS, initData, DROP_DOWNS } from './config';
import { Paths } from 'common/constants/paths';
import { PathNames } from 'common/constants/pathNames';
import { ToolTip } from 'common/components/toolTip/toolTip';
import { DropDownBox } from '../Integration/DropDownBox/DropDownBox';
import { IDropDown, IField, SECURE_INPUT_MASK } from '../config';
import { useDispatch } from 'react-redux';
import { loadList } from 'features/IntegrationsSlice';
import { tosterService } from 'common/services/tostar.service';

export function Splunk(props: any) {
  const [loading, setLoading] = useState<boolean>(true);
  const [submiting, setSubmiting] = useState<boolean>(false);
  const [data, setData] = useState<ISplunk>(initData());
  const [error, setError] = useState<string>('');
  const [isValidated, setIsValidated] = useState<boolean>(false);
  const [submitEnabled, setSubmitEnabled] = useState<boolean>(false);
  const dispatch = useDispatch<any>();

  useEffect(() => {
    if (props.isEditMode) {
      RestApi.getData(Paths[PathNames.integrationSplunk] + props.id + '/').subscribe((response: any) => {
        if (response) {
          setData({ ...response, hec_token: SECURE_INPUT_MASK });
          setLoading(false);
        }
      });
    } else {
      setLoading(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.isEditMode]);

  const setValue = (key: string, value: any) => {
    let copy: ISplunk = { ...data };
    copy = { ...copy, [key]: value };
    setData(copy);
    setSubmitEnabled(true);
  };

  const submit = () => {
    setSubmiting(true);
    RestApi.setData(
      props.isEditMode ? Paths[PathNames.integrationSplunk] + props.id + '/' : Paths[PathNames.integrationSplunk],
      {
        ...data,
        is_active: true,
        hec_token: data.hec_token === SECURE_INPUT_MASK ? undefined : data.hec_token
      },
      props.isEditMode ? 'PATCH' : 'POST'
    ).subscribe(
      (response: any) => {
        setSubmiting(false);
        props.onClose();
        dispatch(loadList());
        tosterService.onShowToster(`Integration Saved Successfully`, 'success', '');
      },
      error => {
        // const _err = JSON.parse(error.message);
        setError('Something Went Wrong');
        setSubmiting(false);
      }
    );
  };

  useEffect(() => {
    if (
      data.hec_token.length > 2 &&
      data.splunk_server.length > 5 &&
      ((data.unlinked_ips_is_active && data.unlinked_ips_push_interval > 0) ||
        (data.action_items_is_active && data.action_items_push_interval > 0))
    ) {
      setIsValidated(true);
    } else {
      setIsValidated(false);
    }
  }, [data]);

  if (loading) {
    return <AppLoading />;
  }

  return (
    <div className="Splunk integration">
      <IntegrationHeader name="Splunk" icon="splunk" />
      <div className="scrollbar-common">
        <div className="main-integration-wrapper">
          <div style={{ height: '100%', overflow: 'auto' }}>
            <div className="group">
              <div className="group-headline">
                <h6>General</h6>
              </div>
              {FIELDS.map((field: IField) => {
                return (
                  <div className="text-field-wrapper" key={field.label}>
                    <TextField
                      fullWidth
                      label={field.label}
                      className="input"
                      value={data[field.field as keyof ISplunk]}
                      onChange={e => setValue(field.field, e.target.value)}
                    />
                    {field.info && (
                      <img src="/assets/images/info.svg" className="info" data-tip={field.info} alt="Info" />
                    )}
                  </div>
                );
              })}
            </div>
            <div className="group">
              <div className="group-headline">
                <h6>Set Time Intervals</h6>
              </div>
              <ul>
                {DROP_DOWNS.map((dropdown: IDropDown) => {
                  return (
                    <DropDownBox
                      key={dropdown.label}
                      data={dropdown}
                      selectedItem={
                        dropdown.options.filter(
                          option => option.value === data[dropdown.valueField as keyof ISplunk]
                        )[0]
                      }
                      isActive={data[dropdown.activationField as keyof ISplunk]}
                      onToggle={(state: boolean) => setValue(dropdown.activationField, state)}
                      onChange={(state: boolean) => setValue(dropdown.valueField, state)}
                    />
                  );
                })}
              </ul>
            </div>
          </div>
        </div>
      </div>
      {!loading && (
        <ButtonsWrapper
          onClose={props.onClose}
          isValidated={submitEnabled && isValidated}
          onSave={submit}
          isSubmiting={submiting}
          error={error}
        />
      )}
      <ToolTip theme="dark" place="left" />
    </div>
  );
}
